<template>
    <form ref="form" v-on="formEvents">
        <div class="form-group">
            <label>Beneficiary Phone Number</label>
            <phone-input v-model="form.receiver" :countries="['ZW']" @input="showForm"></phone-input>
            <div v-text="form.errors.get('receiver')" class=" bg-danger rounded-bottom text-white text-center text-1 mt-0"/>
            <div class="alert alert-info mt-2 text-center"  v-if="form.errors.get('receiver')">
                <small>
                    Correct your phone & try again <b>OR</b> Buy
                    <router-link to="/airtime/netone"  class="ml-1 btn btn-sm bg-white shadow-none">
                        <img  class="bill-img" :src="logos.NetOne" height="10" alt="">
                    </router-link>
                </small>
            </div>
        </div>
        <transition name="slide-in-top">
            <div>
                <div class="form-group">
                    <label>Pay with</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text input-icon">
                                <i class="fa fa-credit-card"></i>
                            </span>
                        </div>
                        <select v-model="form.payment"
                                :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                            <option v-if="form.currency === 'ZWG'" value="ecocash">EcoCash ZWG</option>
                            <option value="ecocash-usd">EcoCash USD</option>
                            <option value="stripe">International Card</option>
                        </select>
                    </div>
                    <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
                </div>

                <div v-if="form.payment === 'ecocash' || form.payment === 'ecocash-usd' " class="form-group">
                    <label>EcoCash Phone Number</label>
                    <phone-input key="1" v-model="form.phone" :countries="['ZW']"></phone-input>
                    <div v-text="form.errors.get('phone')" class="text-danger"/>
                    <small class="text-black-50">* Also used for notifications</small>
                </div>

                <div class="form-group">
                    <label>Amount</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text input-icon">
                                <img :src="flags[methods[form.payment]]" class="currency-icon mr-1" alt="">
                                {{ methods[form.payment] }}
                            </span>
                        </div>
                        <input required min="0.01" step="any" type="number" v-model="form.amount"
                               :class="[ 'form-control' , form.errors.get('amount') ? 'is-invalid' : '' ]"
                               placeholder="Amount">
                    </div>
                    <div v-text="form.errors.get('amount')" class="invalid-feedback"/>
                </div>
                <div class="form-group d-flex align-items-center">
                    <input type="checkbox" class="mr-2" id="checkterms" v-model="termsAccepted">
                    <label class="mb-0" for="checkterms">I accept the <a target="_blank" href="/terms">Terms & Conditions</a></label>
                </div>
            </div>
        </transition>
        <transition name="slide-in-top">
            <div v-if="form.payment === 'stripe'" class="form-group">
                <label>Email</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                            <span class="input-group-text input-icon">
                                <i class="fa fa-envelope"></i>
                            </span>
                    </div>
                    <input type="email" v-model="form.email" value="email"
                           required
                           :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                           placeholder="Email">
                </div>
                <div v-text="form.errors.get('email')" class="invalid-feedback"/>
            </div>
        </transition>
        <div class="form-group">
            <button type="button"
                    v-bind="buttonValidity"
                    :class="{'btn-loading': form.loading, ...buttonValidity.class }"
                    @click="formVisibility ? submit($event) : (formVisibility = true)">
                Buy Airtime
            </button>
        </div>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import {validity} from "../../../core/forms/validity";
import PhoneInput from "../../custom/phone-input";
import {appDataMixin} from "../../../core/data/global";
import {createBiDirectionalObject} from "../../../core/utils/bi-directional-obj";

const paymentMethods = createBiDirectionalObject({
    'ecocash': 'ZWG',
    'ecocash-usd':'USD',
    'stripe': 'USD',
})

export default {
    name: "dashboard",
    components: {PhoneInput},
    mixins: [validity, appDataMixin],
    data: function () {
        return {
            meterLoading: false,
            fields: [
                'receiver',
                'phone',
                'email',
            ],
            methods: {...paymentMethods},
            meter: {},
            form: new Form({
                'receiver': '',
                'payment': '',
                'network': 'econet',
                'phone': '',
                'amount': '',
                'email': '',
                'currency': this.currency,
            })
        };
    },
/*
    watch: {
        'form.receiver'(v) {
            if (v && v.startsWith('26371')) this.form.network = 'netone';
            else if (v && v.startsWith('26377')) this.form.network = 'econet';
            else if (v && v.startsWith('26378')) this.form.network = 'econet';
            else if (v && v.startsWith('26379')) this.form.network = 'econet';
            else this.form.network = '';
        }
    },*/

    methods: {
        saveToLocalStorage() {
            for (const item of this.fields) {
                localStorage.setItem(item, this.form[item]);
            }
        },

        getFromLocalStorage() {
            for (const item of this.fields) {
                let value = localStorage.getItem(item);
                if (value != null && value !== "" && value !== "null") {
                    this.form[item] = value;
                }
            }
        },

        submit(event) {
            this.form.currency = this.currency;

            // Save to Local Storage

            if (this.valid) {
                event.preventDefault();

                this.saveToLocalStorage();
                this.form.submit('/bills/airtime/init').then((response) => {

                    // Redirect based on payment type
                    if (response.data.success) {
                        if (response.data.body.payment.payment === "ecocash" || response.data.body.payment.payment === "ecocash-usd") {
                            this.$router.push(`/airtime/ecocash?id=${response.data.body.payment.ref}`);
                        }

                        if (response.data.body.payment.payment === "stripe") {
                            window.location.href = response.data.body.payment.url;
                        }

                    } else {

                    }
                });
            }
        }
    },

    mounted() {
        this.scrollToTop();
        // Check in Local Storage
        this.getFromLocalStorage();
        this.form.currency = this.currency;
        this.form.payment = paymentMethods[this.currency]
    }
}
</script>
